import React from 'react';
import Maps from '../components/Maps';

const Busca = (props) => {
   return(
      <div className="map">
         <Maps />
      </div>
      
   )
}

export default Busca;